export default __webpack_public_path__ + "static/media/unplugged.fc389494.svg";